export const MEV_MODULE_NAME = "mev_module";

export const mevModuleMenuItem = {
  icon: "gavel",
  path: "/mev",
};

export const mevModuleRoutes = [
  {
    path: "mev",
    name: "MevCausas",
    components: {
      default: () => import("./pages/MevCausas.vue"),
    },
    meta: {
      title: "MEV — Causas",
      requiresAuth: true,
      requiresModule: MEV_MODULE_NAME,
    },
  },
];

export default {
  moduleName: MEV_MODULE_NAME,
  routes: mevModuleRoutes,
  menuItem: mevModuleMenuItem,
};
